/**
 * Interface para configuração do MaxGraph
 */
export interface MaxGraphConfig {
    rubberBand:   boolean,
    contextMenu:  boolean,
    connectable:  boolean,
    enabled:      boolean,
    tooltips:     boolean,
    panning:      boolean,
    centerZoom:   boolean,
    tooltipDelay: number
}

/**
 * Configuração padrão para o MaxGraph
 */
export const DEFAULT_MAX_GRAPH_CONFIG: MaxGraphConfig = {
    rubberBand:   true,
    contextMenu:  false,
    connectable:  true,
    enabled:      false,
    tooltips:     true,
    panning:      true,
    centerZoom:   false,
    tooltipDelay: 200
}
